class AppUrl {

    static BaseUrl='https://portfolio-laravel-rest-api.herokuapp.com/';
    static HomeTopTitle=this.BaseUrl+'/HomeTopTitle';
    static TechDesc=this.BaseUrl+'/TechDesc';
    static TotalProjectClient=this.BaseUrl+'/TotalProjectClient';
    static VideoHome=this.BaseUrl+'/VideoHome';
    static ProjectDetails=this.BaseUrl+'/ProjectDetails/';
    static ProjectAll=this.BaseUrl+'/ProjectAll';
    static Project3=this.BaseUrl+'/Project3';
    static Services=this.BaseUrl+'/Services';
    static Information=this.BaseUrl+'/Information';
    static Footer=this.BaseUrl+'/Footer';
    static CourseDetails=this.BaseUrl+'/CourseDetails/';
    static CourseAll=this.BaseUrl+'/CourseAll';
    static CourseHome=this.BaseUrl+'/CourseHome';
    static ContactSend=this.BaseUrl+'/ContactSend';
    static ClientReview=this.BaseUrl+'/ClientReview';
    static ChartData=this.BaseUrl+'/ChartData';
}

export default AppUrl;